<template>
  <div :class="luigiClasses">
    <header id="header">
      <HeaderInheritedArea />
    </header>
    <KikNotification />
    <main id="main">
      <NuxtPage />
    </main>
    <KikToTop />
    <footer id="footer">
      <InheritedPreFooterArea />
      <CategoryDescription />
      <FooterInheritedArea />
    </footer>
  </div>
</template>

<script lang="ts" setup>
import config from '~/magnolia/magnolia.config';
import InheritedPreFooterArea from '~/components/Footer/PreFooter/InheritedArea.vue';
import { useWindow } from '~/composables/useWindow';
import { useUser } from '~/composables/custom/useUser/useUser';
import { useSSR } from '~/composables/useSSR/useSSR';
import { useInContextEditor } from '~/composables/useInContextEditor';
import useUiNotification from '~/composables/useUiNotification';

defineComponent({
  name: 'DefaultLayout',
});

const { load: loadCategories, result: categories } = useCategories();
const { load: loadUser, isAuthenticated } = useUser();
const { onSSR } = useSSR();
const router = useRouter();
const { showLoginDrawer, closeLoginDrawer } = useUiState();
const { setOverallInfo } = useSeo();
const { classes: luigiClasses } = useLuigisbox();
const { init } = useInContextEditor();
const { send } = useUiNotification();

useWindow();

provide('config', config);
provide('templateAnnotations', {});
provide('content', {});

onSSR(async () => {
  setOverallInfo();
  if (!categories.value?.length) {
    await loadCategories();
  }
});

onBeforeMount(async () => {
  await loadUser();
});

onMounted(() => {
  init();
  handleStatusCodes();
});

const handleStatusCodes = () => {
  const status = router.currentRoute.value.query.status as string | undefined;
  if (status) {
    switch (status) {
      case 'IMUPS':
        send({
          icon: 'profile_filled',
          message: 'Password Changed',
          type: 'success',
        });
        break;
      default:
        break;
    }
  }
};

watch([router.currentRoute, isAuthenticated], async () => {
  if (router.currentRoute.value.query.redirectTo && import.meta.browser) {
    if (!isAuthenticated.value) {
      showLoginDrawer();
      return;
    }

    closeLoginDrawer();
    await navigateTo(decodeURIComponent(router.currentRoute.value.query.redirectTo as string));
  }
}, { immediate: true });
</script>
